import { parsePhoneNumberFromString } from "libphonenumber-js";
import type { PropertyPreviewProps } from "@firecms/core";
import { cls } from "@firecms/ui";

/** 當地撥打的號碼，只留數字，例如 +886933324966 → 0933324966；解析不了回傳 null */
function localPhoneNumber(e164: string): string | null {
  return parsePhoneNumberFromString(e164)?.formatNational().replace(/\D/g, "") || null;
}

/**
 * 電話存成 E.164，後台先顯示當地號碼、再顯示帶國碼的號碼，兩個都能直接複製到物流後台。
 * 欄位寬就排成一行（當地號碼在前），窄的時候（例如表格）換成兩行（當地號碼在上）。
 */
export function PhonePreview({ value, size }: PropertyPreviewProps<string>) {
  if (!value) return null;
  const local = localPhoneNumber(value);
  return (
    <span className={cls("flex flex-wrap gap-x-3", size === "small" && "text-sm")}>
      {local && <span className="whitespace-nowrap">{local}</span>}
      <span className="whitespace-nowrap">{value}</span>
    </span>
  );
}
